import React from 'react';
import { Flower2, Heart, Truck, Award } from 'lucide-react';

const NosotrosPage = () => {
  return (
    <div className="min-h-screen bg-pink-50 pt-20">
      {/* Hero Section */}
      <section 
        className="py-20 px-4"
        style={{
          backgroundImage: 'url(https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e9bba638-d807-427f-bea3-a775809cad00/publicContain)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-pink-900 mb-6">
            Sobre Tqm Florería
          </h1>
          <p className="text-xl md:text-2xl text-pink-800">
            Llevamos amor y alegría en cada arreglo floral
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-pink-900 mb-6">Nuestra Historia</h2>
            <p className="text-gray-700 text-lg mb-6">
              Tqm Florería nació con la misión de hacer que cada momento especial sea inolvidable. 
              Nos especializamos en crear arreglos florales únicos que transmiten emociones y 
              sentimientos a través de la belleza natural de las flores.
            </p>
            <p className="text-gray-700 text-lg mb-6">
              En Arequipa, somos reconocidos por nuestra calidad, frescura y compromiso con la 
              satisfacción de nuestros clientes. Cada arreglo es elaborado con dedicación y amor, 
              seleccionando las mejores flores para garantizar que tu regalo sea perfecto.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 px-4 bg-pink-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-pink-900 mb-12">Nuestros Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full mb-4">
                <Flower2 className="w-8 h-8 text-pink-600" />
              </div>
              <h3 className="text-xl font-bold text-pink-900 mb-2">Calidad Premium</h3>
              <p className="text-gray-700">Flores frescas de la más alta calidad</p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full mb-4">
                <Heart className="w-8 h-8 text-pink-600" />
              </div>
              <h3 className="text-xl font-bold text-pink-900 mb-2">Pasión</h3>
              <p className="text-gray-700">Amor en cada detalle de nuestros arreglos</p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full mb-4">
                <Truck className="w-8 h-8 text-pink-600" />
              </div>
              <h3 className="text-xl font-bold text-pink-900 mb-2">Puntualidad</h3>
              <p className="text-gray-700">Entrega rápida en menos de 3 horas</p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full mb-4">
                <Award className="w-8 h-8 text-pink-600" />
              </div>
              <h3 className="text-xl font-bold text-pink-900 mb-2">Excelencia</h3>
              <p className="text-gray-700">Compromiso con tu satisfacción</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-pink-900 mb-6">
            ¿Listo para Hacer un Pedido?
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Contáctanos por WhatsApp y te ayudaremos a elegir el arreglo perfecto
          </p>
          <button
            onClick={() => window.open('https://wa.me/51959389799?text=Hola,%20quiero%20hacer%20un%20pedido', '_blank')}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-2"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            Contactar por WhatsApp
          </button>
        </div>
      </section>
    </div>
  );
};

export default NosotrosPage;